// src/theme/tokens.spacing.ts

// Valores en píxeles, copiados del UI Kit
export const spacingPx = {
  0: 0, // space-0   → 0px
  2: 2, // space-2   → 2px
  4: 4, // space-4   → 4px
  6: 6, // space-6   → 6px
  8: 8, // space-8   → 8px
  12: 12, // space-12  → 12px
  16: 16, // space-16  → 16px
  20: 20, // space-20  → 20px
  24: 24, // space-24  → 24px
  32: 32, // space-32  → 32px
  40: 40, // space-40  → 40px
  48: 48, // space-48  → 48px
  64: 64, // space-64  → 64px
  80: 80, // space-80  → 80px
} as const;

export type SpacingToken = keyof typeof spacingPx;

// Helper si querés usarlo directo en CSS-in-JS
export const spacing = (token: SpacingToken): string => `${spacingPx[token]}px`;
